module.exports = __webpack_public_path__ + "img/header-engagementRingsPrincess@2x.72d052f.jpg";